import { Grid, Icons, Stack } from '@/theme/index';
import { GridItem, SectionTitle, TileItem } from '../components';

export interface FraudIpOverviewProps {
  country: string;
  region: string;
  city: string;
  isp: string;
}

export function FraudIpOverview({
  country,
  region,
  city,
  isp,
}: FraudIpOverviewProps) {
  return (
    <Stack>
      <SectionTitle>Overview</SectionTitle>

      <Grid container spacing={2}>
        <GridItem>
          <TileItem
            title="Country"
            text={country || 'Unknown'}
            IconComponent={Icons.Flag}
            testLabelId="ip-overview-country-label"
            testContentId="ip-overview-country"
          />
        </GridItem>

        <GridItem>
          <TileItem
            title="Region/State"
            text={region || 'Unknown'}
            IconComponent={Icons.LocationCity}
            testLabelId="ip-overview-region-label"
            testContentId="ip-overview-region"
          />
        </GridItem>

        <GridItem>
          <TileItem
            title="City:"
            text={city || 'Unknown'}
            IconComponent={Icons.LocationCity}
            testLabelId="ip-overview-city-label"
            testContentId="ip-overview-city"
          />
        </GridItem>

        <GridItem>
          <TileItem
            title="ISP:"
            text={isp}
            IconComponent={Icons.Info}
            testLabelId="ip-overview-isp-label"
            testContentId="ip-overview-isp"
          />
        </GridItem>
      </Grid>
    </Stack>
  );
}
